import CreateEnterpriseProvider from '@enterprise/contexts/createEnterpriseContext';
import EnterpriseEditForm from './EnterpriseEditForm';

const EditEnterprisePage = () => {
  return (
    <CreateEnterpriseProvider>
      <EnterpriseEditForm />
    </CreateEnterpriseProvider>
  );
};

export default EditEnterprisePage;
